"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageStacks5 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ImageStacks5 = function (_a) {
    var image = _a.image, columns = _a.columns;
    return ((0, jsx_runtime_1.jsx)("section", __assign({ className: "section-padding-lg" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "container" }, { children: [(0, jsx_runtime_1.jsx)("img", { className: "img-fluid mb-10", src: image, alt: "" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "row" }, { children: columns.map(function (item, index) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "col-md-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "pe-lg-6" }, { children: [(0, jsx_runtime_1.jsx)("h6", __assign({ className: "fw-normal" }, { children: item.heading })), (0, jsx_runtime_1.jsx)("p", __assign({ className: (0, classnames_1.default)('small pb-6 line-after', index !== columns.length - 1 ? 'mb-8 mb-md-0' : 'mb-0') }, { children: item.paragraph }))] })) }), item.heading)); }) }))] })) })));
};
exports.ImageStacks5 = ImageStacks5;
